/**
 * Lo que un rol puede hacer en el terminal del POS (PLAN_POS_IMPLEMENTACION §2.4).
 *
 * Copia del catálogo cerrado de `backend/apps/pos/capabilities.py`, en el mismo
 * orden: `test_catalogo_de_capacidades_igual_al_frontend` falla si se separan.
 */
export interface PosCapability {
  key: string
  label: string
  hint: string
}

export const POS_CAPABILITIES: PosCapability[] = [
  { key: 'sell', label: 'Vender y cobrar', hint: 'Abrir una venta, cobrarla y emitir la boleta.' },
  { key: 'cash.open_close_own', label: 'Abrir y cerrar la propia caja', hint: 'Con el arqueo del cierre.' },
  { key: 'discount.line', label: 'Descuento por línea', hint: 'Sin autorización hasta el tope del rol; sobre el tope, lo autoriza un supervisor.' },
  { key: 'discount.global', label: 'Descuento global', hint: 'Un descuento sobre el total de la venta.' },
  { key: 'void.before_print', label: 'Anular antes de imprimir', hint: 'Descartar una venta que todavía no se imprimió.' },
  { key: 'credit_note', label: 'Emitir nota de crédito', hint: 'Devoluciones y correcciones de una boleta ya emitida.' },
  { key: 'cash.withdraw', label: 'Retiro de efectivo', hint: 'Sacar efectivo de la caja, con motivo.' },
  { key: 'reprint', label: 'Reimprimir', hint: 'Volver a imprimir un documento ya emitido.' },
  { key: 'cash.close_other', label: 'Cerrar una caja ajena', hint: 'Cerrar la caja que abrió otra persona.' },
  { key: 'authorize', label: 'Autorizar en la caja', hint: 'Aprobar con su PIN lo que otra persona no puede hacer sola. Exige un PIN de 6 dígitos o más.' },
  { key: 'terminal.configure', label: 'Configurar el terminal', hint: 'Impresora, balanza y modo de operación.' },
]

const SUPERVISOR = POS_CAPABILITIES.map((c) => c.key).filter((k) => k !== 'terminal.configure')

/** Las que traen los roles del sistema (espejo de `DEFAULTS` del backend). */
export const POS_CAPABILITY_DEFAULTS: Record<string, { capabilities: string[]; maxDiscount: string }> = {
  cashier: { capabilities: ['sell', 'cash.open_close_own'], maxDiscount: '0' },
  store_manager: { capabilities: SUPERVISOR, maxDiscount: '100' },
  admin: { capabilities: POS_CAPABILITIES.map((c) => c.key), maxDiscount: '100' },
}
